import React, { FormEvent, useState } from "react";
import { api } from "shared/api";
import { useApiMethod, UseModalProps } from "shared/lib";
import { Error, Input, LoadingDots, Modal } from "shared/ui";

export interface IIncomeTypeCreateModal extends UseModalProps {
  companySlug: string;
}

export const IncomeTypeCreateModal = (props: IIncomeTypeCreateModal) => {
  const incomeTypeList = api.incomeType.useIncomeTypeList(props.companySlug);
  const submit = useApiMethod(api.incomeType.incomeTypeCreate);

  const [name, setName] = useState("");

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!name) return;

    await submit.call(props.companySlug, { name });
    await incomeTypeList.mutate();
    await props.onSuccess();
  };

  return (
    <Modal onClose={props.close} width={400}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Новый тип дохода</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Input autoFocus placeholder="Название" value={name} onChange={(e) => setName(e.target.value)} required />

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Назад
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading}>
            {!submit.loading ? "Создать" : <LoadingDots size={4}>Создаем</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

IncomeTypeCreateModal.defaultProps = {};
